import { browserHistory } from 'react-router';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import UserAPI from '../util/UserAPI';
import auth from '../config/auth0-config';
import TokenStore from '../stores/TokenStore';


function doLogout() {
  AppDispatcher.dispatch({
    actionType: Constants.USER_LOGGED_OUT,
  });

  auth.logout();
}

const AuthActions = {
  authenticated(authResult) {
    AppDispatcher.dispatch({
      actionType: Constants.USER_AUTHENTICATED,
      authResult,
    });
    if (sessionStorage.getItem('redirectOnLogin')) {
      const target = sessionStorage.getItem('redirectOnLogin');
      sessionStorage.removeItem('redirectOnLogin');
      browserHistory.replace(target);
    }
  },

  authenticationFailed(authErr) {
    AppDispatcher.dispatch({
      actionType: Constants.USER_AUTHENTICATION_FAILED,
      authErr,
    });
  },

  loadUserInfo() {
    auth.getUserInfo(TokenStore.getAccessToken(), (error, profile) => {
      if (!error) {
        AppDispatcher.dispatch({
          actionType: Constants.PROFILE_LOADED,
          profile,
        });
        new UserAPI(TokenStore.getToken()).users.getCurrentUser().then((response) => {
          // Log in current user
          AppDispatcher.dispatch({
            actionType: Constants.Admin.CURRENT_USER_LOADED,
            user: response.user,
          });
        }).catch((error) => {
          console.error('Login Error: ', error.stack);
          // Unauthorized. Credentials probably expired. Kill cached credentials.
          doLogout();
        });
      } else {
        console.error(error);
        // Unauthorized. Credentials probably expired. Kill cached credentials.
        doLogout();
      }
    });
  },


  logout() {
    if (TokenStore.isGoogle()) {
      sessionStorage.setItem('googleLogout', true);
    }
    doLogout();
  },

};

export default AuthActions;
